export default {
  auth_request(state) {
    state.authStatus = "loading";
  },
  auth_success(state, { token }) {
    state.authStatus = "success";
    state.token = token;
  },
  auth_error(state) {
    state.authStatus = "error";
  },
  user_success(state, { user }) {
    state.user = user;
  },
  logout(state) {
    state.authStatus = "";
    state.token = "";
    state.user = "";
  }
};
